import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAreaUpd = async (credentials, data) => {
    const body = {
        service: "RNHAreaUpd",
        params: {
            rnhAreaId: data?.id,
            rnhAreaNombre: data?.name,
            rnhAreaCod: data?.cod,
            // Por COD y no por id, igual que RNHAreaIns. El area se sigue identificando
            // por `rnhAreaId`, que RNHAreaGet si devuelve; lo que nunca vino en esa
            // response es el id de la zona, solo su `rnhZonaCod`.
            rnhZonaCod: data?.zonaCod,
            rnhAreaWKT: data?.wkt,
            rnhAreaVersion: data?.version,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
